import { commonEnvironment } from '@portal-shared/environments/environment.common';
import { IEnvironment } from '@portal-shared/environments/environment.interface';

export const environment: IEnvironment = {
  ...commonEnvironment,
  build: 'prod'
};
